import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f5f88892"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "home-wrapper",
  id: "home-wrapper"
};
const _hoisted_2 = {
  class: "course-box"
};
import Head from '@/components/Head';
import Footer from '@/components/Footer';
import Banner from './components/Banner';
import Mooc from './components/Mooc';
import Spoc from './components/Spoc';
import DataStatistic from './components/DataStatistic';
import MenuCard from './components/MenuCard';
import autofit from 'autofit.js';
export default {
  setup(__props) {
    const $http = inject('$http');
    const bannerItem = ref();
    const moocItem = ref();
    const spocItem = ref();
    const statisticItem = ref();
    const footerItem = ref(); // 获取首页数据

    const getHomeList = async () => {
      const res = await $http.getDataList();
      bannerItem.value = res.find(item => item.function_id === '10302' && item.home_open);
      moocItem.value = res.find(item => item.function_id === '10401' && item.home_open);
      spocItem.value = res.find(item => item.function_id === '10402' && item.home_open);
      statisticItem.value = res.find(item => item.function_id === '10304' && item.home_open);
      footerItem.value = res.find(item => item.function_id === '10303' && item.home_open);
    };

    getHomeList();
    autofit.init({
      designHeight: 1080,
      designWidth: 1920,
      renderDom: '#home-wrapper',
      resize: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Head)), bannerItem.value ? (_openBlock(), _createBlock(_unref(Banner), {
        key: 0
      })) : _createCommentVNode("", true), _createVNode(_unref(MenuCard)), _createElementVNode("div", _hoisted_2, [moocItem.value ? (_openBlock(), _createBlock(_unref(Mooc), {
        key: 0,
        menu: moocItem.value
      }, null, 8, ["menu"])) : _createCommentVNode("", true), spocItem.value ? (_openBlock(), _createBlock(_unref(Spoc), {
        key: 1,
        menu: spocItem.value
      }, null, 8, ["menu"])) : _createCommentVNode("", true), statisticItem.value ? (_openBlock(), _createBlock(_unref(DataStatistic), {
        key: 2,
        menu: statisticItem.value
      }, null, 8, ["menu"])) : _createCommentVNode("", true)]), _createVNode(_unref(Footer), {
        menu: footerItem.value
      }, null, 8, ["menu"])]);
    };
  }

};